import React from 'react'
import LeavesLg from '../../../components/AdminComponents/LeavesLg'
import {BiTimeFive} from 'react-icons/bi'
import { AiOutlineCalendar, AiOutlineCheck, AiOutlineClockCircle, AiOutlineClose } from 'react-icons/ai';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { UseHrApp } from '../../../utils/context';

export default function Leave() {

  const { token } = UseHrApp();

  async function getAllLeaves() {
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/leave/all",
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.data?.status) {
        setleaves(res?.data?.data);
      }
    } catch (error) {
      console.log("Failed");
    }
  }

  useEffect(()=>{
    getAllLeaves()
  },[])

  

  const [leaves, setleaves] = useState([]);
  const [totalLeaves, setTotalLeaves] = useState(200);
  const [pendingLeaves, setPendingLeaves] = useState(0);
  const [approvedLeaves, setApprovedLeaves] = useState(0);
  const [rejectedLeaves, setRejectedLeaves] = useState(0);


  useEffect(() => {
    // Calculate total, pending, approved, and rejected leaves
    setTotalLeaves(leaves.length);
    setPendingLeaves(leaves.filter(item => item.status === "Pending").length);
    setApprovedLeaves(leaves.filter(item => item.status === "Approved").length);
    setRejectedLeaves(leaves.filter(item => item.status === "Rejected").length);
  }, [leaves]);

  return (
    <div     className=' min-w-screen min-h-[91vh] bg-[#f4f8fd] font-[Archivo]'>
    <div className=' p-3 md:pl-[16em] lg:pl-[16em] lg:pr-[1em] xl:pl-[17em] xl:pr-[2em] w-full pt-[1em] '>
<div className=' w-full flex justify-between items-center'>
<p className=' font-[Archivo] lg:text-2xl font-semibold'>Leaves</p>
</div>
<div className=' w-full grid md:grid-cols-2 lg:grid-cols-4 md:gap-3  mt-3 lg:gap-4'>
  <div className=' w-full h-[6em] bg-[#ffffff] box3 justify-between flex  items-center p-4 '>
    <div><p>{totalLeaves}</p>
    <p className=' text-[#262626] lg:text-sm '>
      Total Leaves 
      </p></div>
      <div className=" w-[50px] h-[50px]  rounded-[4em] bg-[#E1D6FF] flex justify-center items-center">
<AiOutlineCalendar size={20}/>
      </div>
  </div>

  <div className=' w-full h-[6em] bg-[#ffffff] box3 justify-between flex  items-center p-4 '>
    <div><p>{pendingLeaves}</p>
    <p className=' text-[#262626] lg:text-sm'>
      Pending
      </p></div>
      <div className=" w-[50px] h-[50px]  rounded-[4em] bg-[#FDF6C8] flex justify-center items-center">
<AiOutlineClockCircle size={20}/>
      </div>
  </div>

  <div className=' w-full h-[6em] bg-[#ffffff] box3 justify-between flex  items-center p-4 '>
    <div><p>{approvedLeaves}</p>
    <p className=' text-[#262626] lg:text-sm'>
      Approved
      </p></div>
      <div className=" w-[50px] h-[50px]  rounded-[4em]   flex justify-center items-center bg-[#BDF3C0]">
<AiOutlineCheck size={20}/>
      </div>
  </div>

  <div className=' w-full h-[6em] bg-[#ffffff] box3 justify-between flex  items-center p-4 '>
    <div><p>{rejectedLeaves}</p>
    <p className=' text-[#262626] lg:text-sm'>
      Rejected
      </p></div>
      <div className=" w-[50px] h-[50px]  rounded-[4em] bg-[#F9C0C0] flex justify-center items-center">
<AiOutlineClose size={20}/>
      </div>
  </div>





  </div>

  
  <div className=' mt-8'>
    <div><p className=' md:text-xl lg:text-2xl font-semibold font-[Archivo] py-[10px]'>History</p></div>
   

    <LeavesLg/>
    </div>


</div>

    </div>

  )
}
